// extracted by css-extract-rspack-plugin
export default {"selectSkeleton":"S_goKzkJ1JgyNRj8","headerUserNameSkeleton":"f_RvK3LXHUPVynRz"};